import { HC_LINEAR_AUTH_APP_ROUTES } from '@hclinear/hc-linear-react';

export const APP_ROUTES = {
  HOME: '/',
  DASHBOARD: '/dashboard',

  ERROR: '/error',

  ...HC_LINEAR_AUTH_APP_ROUTES,
  USER: {
    PROFILE: '/profile',
    ...HC_LINEAR_AUTH_APP_ROUTES.USER,
  },

  MONITORING: {
    DASHBOARD: '/',
    STOP_MAP: '/stop-map',
    STOP_TERMINAL_STATUS: '/stop-terminal-status',
    PRODUCT_LOG: '/product-log',
    PRODUCT_CONSOLE: '/product-console',
    TIMETABLE_DATA: '/timetable-data',
    TERMINAL_TIME_CHART: '/terminal-time-chart',
    ALERTS: '/alerts',
  },

  REAL_VIEW: {
    PRODUCT_LIST: '/product',
    STOP_LIST: '/stop',
  },

  TEMPLATES: {
    IMAGES: '/images',
    LAYOUTS: '/layouts',
    TIMETABLES: '/timetables',
    TIMETABLE_EDITOR: '/timetable-editor/$timeTableId',
    STOP_TEMPLATE: '/stop-template',
    OPERATIONAL_SCHEMES: '/operational-schemes',
    FONT_LIST: '/fonts',
    DISPLAY_LIST: '/displays',
    LAYOUT_EDITOR_BASE: '/layout-editor',
    LAYOUT_EDITOR: '/layout-editor/$layoutId',
    DICTIONARY: '/dictionary',
  },

  SYSTEM: {
    GROUPS: '/groups',
    COMPANIES: '/companies',
    USERS: '/users',
    SERVER_LIST: '/server-list',
  },

  FIRMWARE: {
    FIRMWARE_LIST: '/firmware',
    FIRMWARE_TERMINAL_UPDATE_LIST: '/firmware-terminal-update-list',
    HARDWARE_VERSIONS: '/hardware-versions',
  },

  ANNOUNCEMENTS: {
    ANNOUNCEMENTS: '/announcements',
    EDITOR: '/announcements/editor/$id/$itemId',
    FLAG: '/flag',
  },

  ABOUT: '/about',
  SETTINGS: '/settings',
} as const;
